// Port of api/fuel/app/classes/filter/search/games/rules/query/play_status.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_status',
	match: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)

		if (rule.logic.value === 'complete') {
			query.where('p.play_incomplete', '=', '0')
		} else if (rule.logic.value === 'incomplete') {
			query.where('p.play_incomplete', '=', '1')
		}
	}
})
